import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Button } from 'components/ui/button';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import OffsetInput from './offset_input';
import Options from 'components/form/managed_input/options';
import { Errors } from 'components/ui/errors';

import { addDefaultReminder } from './store/default_reminders/actions';
import { buildDefaultReminder, recipientsOptions } from './config';
import { getOrderedStages } from 'bundles/apex/helpers/stages';
import { getStageOptions } from './helpers';

export function CompanyRemindersModal({ addDefaultReminder, criticalDateOptions, show, stagesConfig, onHide }) {
  const [saving, setSaving] = useState(false);
  const [reminder, setReminder] = useState({});
  const [errors, setErrors] = useState();
  const updateReminder = changes => setReminder(prevState => ({ ...prevState, ...changes }));

  const stageOptions = getStageOptions(getOrderedStages(stagesConfig));

  const saveReminder = async () => {
    try {
      setSaving(true);
      await addDefaultReminder(reminder);
      onHide();
    } catch (errors) {
      setErrors(errors);
    } finally {
      setSaving(false);
    }
  };

  const onShow = () => {
    setReminder(buildDefaultReminder(criticalDateOptions));
    setErrors(null);
  };

  return (
    <Modal show={show} onHide={onHide} onShow={onShow}>
      <Modal.Header closeButton>
        Add Reminder
      </Modal.Header>
      <Modal.Body>
        <Errors errors={errors} />
        <ManagedFormGroup
          label="Critical Date"
          name="dateReference"
          type="select"
          value={reminder.dateReference}
          onChange={updateReminder}
        >
          <Options options={criticalDateOptions} />
        </ManagedFormGroup>

        <OffsetInput reminder={reminder} onChange={updateReminder} />

        <ManagedFormGroup
          label="Recipients"
          name="recipients"
          type="select"
          value={reminder.recipients}
          onChange={updateReminder}
        >
          <Options options={recipientsOptions} />
        </ManagedFormGroup>

        <ManagedFormGroup
          label="Stage"
          name="stage"
          type="select"
          value={reminder.stage}
          onChange={updateReminder}
        >
          <Options options={stageOptions} />
        </ManagedFormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onHide}/>
        <Button disabled={saving} label="Add Reminder" onClick={saveReminder}/>
      </Modal.Footer>
    </Modal>
  );
}

CompanyRemindersModal.propTypes = {
  addDefaultReminder: PropTypes.func.isRequired,
  criticalDateOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  show: PropTypes.bool,
  stagesConfig: PropTypes.object,
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  criticalDateOptions: state.criticalDateOptions,
  stagesConfig: state.dealStagesConfig,
});

const mapDispatchToProps = {
  addDefaultReminder,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRemindersModal);
